/**
 * Function to throttle a given function by animation frames.
 *
 * @param {function} fn - The function that is to be throttled
 * @return {function} - Returns the throttled function with "cancel" method
 */
export const animationFrameThrottle = fn => {
    let frameId = null
    let lastArgs

    const throttled = function (...args) {
        lastArgs = args
        if (frameId === null) {
            frameId = requestAnimationFrame(() => {
                frameId = null
                fn(...lastArgs)
            })
        }
    }

    throttled.cancel = () => {
        cancelAnimationFrame(frameId)
        frameId = null
    }

    return throttled
}
